import { css } from '@/styled-system/css';

export const actionCardStyles = css.raw({
  flex: 1,
  padding: '400',
  borderRadius: '300',
});

export const sectionFlexStyles = css.raw({
  display: 'flex',
  flexDirection: { base: 'row', lg: 'column' },
  alignItems: 'flex-start',
  justifyContent: { base: 'flex-start', lg: 'space-between' },
  gap: '200',
});
